export const message = {

  //common
  success: 'Success Message',
  error: 'Error',
  warning: 'Warning',
  apiRequestProcessError: 'Error occurred while processing request, please try again.',

  //users-popup
  deleteUser: 'Are you sure to Delete?',
  deleteUserSuccess: 'User deleted successfully.',
  invalidEmail: 'Invalid Email',
  notEmptyEmail: 'Email field should not be empty.',
  notValidEmail: 'Email entered is not a valid email.',
  invalidRole: 'Invalid Role',
  invalidOem: 'Invalid OEM',
  notEmptyOem: 'Select an OEM',
  notEmptyRole: 'Select a role.',
  updateUser: 'Updated successfully.',
  addUser: 'added successfully.',
  errorAddUser: 'Error occurred while adding user, please try again.',
  userExist: 'User already exist', //Changed
  notValidRoleEmail: 'Email or Role is not valid',
  notvalidOem: 'Invalid OEM',
  userblockedMessage: 'You are currently blocked. Please contact system adminidtrator for details or to restore access. <System Admin EMAIL ID>',

  //rules-popup
  invalidController: 'Invalid Controller',
  invalidDevice: 'Invalid Device',
  selectDevice: 'Select Device',
  invalidGroup: 'Invalid Group',
  selectController: 'Select a Controller',
  invalidResource: 'Invalid Resource',
  selectResource: 'Select a Resource',
  invalidMin: 'Invalid Min Value',
  invalidMinDetail: 'Enter a valid Min Value.',
  invalidMax: 'Invalid Max Value',
  invalidMaxDetail: 'Enter a valid Max Value.',
  invalidMaxDis: 'Invalid Max Distance Value',
  invalidMaxDisDetail: 'Enter a valid Max Distance Value.',
  invalidNotifyMail: 'Invalid Notify Mail Ids',
  invalidNotifyDetail: 'Enter valid mail Ids.',
  validController: 'Select a valid controller in apply to section.',
  validDevice: 'Select a valid device in apply to section.',
  validGroup: 'Select a valid group in apply to section.',
  invalidCountry: 'Invalid Countries',
  moreCountriesGen: 'Select one or more countries',
  moreCountries: 'Select one or more countries apply to section.',
  invalidRule: 'Invalid Rule Name',
  invalidRuleDetail: 'Enter a valid rule name.',
  ruleAdd: 'added successfully',
  ruleUpdate: 'updated successfully',
  errorAdd: 'Error occurred while adding/updating Rule, please try again.',
  activeRule: 'Activated successfully',
    deactiveRule: 'Deactivated successfully',
  deleteRule: 'Deleted successfully.',
  confirmDelete: 'Are you sure to Delete Rule?',
  errorDeleteRule: 'Error Deleting Alarm Rule',
  invalidAlarmRuleName: 'Alarm name is not valid',
  duplicateAlarmName: 'Duplicate alarm name',
  invalidResourceMap: 'Invalid Controller type or Resource',
  invalidEmailAlarmRule: 'Notified to email/emails are not valid',
  noUserAccessAlarmRule: 'User Doesn\'t have access to the alarm rule',



  //tenant
  invalidTenantName: 'Invalid TenantName',
  invalidTenantNameDetail: 'Tenant Name field should not be empty.',
  invalidErpNo: 'Invalid ERP No',
  invalidErpNoDetail: 'ERP NO field should not be empty.',
  invalidCoolersCount: 'Invalid CoolersCount',
  invalidCoolersDetail: 'Please enter valid Coolers',
  invalidCoolerValue: 'Invalid Cooler Value',
  invalidCoolerValueDetail: 'Enter a valid Cooler Number Value.',
  invalidExpiry: 'Invalid Expiry Date',
  invalidExpiryDetail: 'Please select Expiry Date',
  tenantAdd: 'Tenant added successfully.',
  tenantError: 'Error occurred while adding tenant, please try again.',
  tenantUpdate: 'Tenant Updated successfully.',
  tenantUpdateError: 'Error occurred while updating tenant, please try again.',
  disableTenantSuccess: 'Tenant Disabled Successfully.',
  moveCoolerSuccess: 'Cooler moved successfully.',
  moveCoolererror1: 'Unknown error occurred, Please try again.',
  moveCoolererror2: 'No cooler/coolers availabe to move',
  moveCoolererror3: 'The target Tenant does not have enough space for the new coolers',
  tenantnotSelected: 'Tenant is not selected',
  selecteTanent: 'Please select Tenant',
  invalidBilling: 'Invalid Biling Address',
  invalidBillingDetails: 'Please enter Billing Address',

  deleteDevice: 'Are you sure to Delete ?',
  blockDevice: 'Are you sure to Block ?',
  unblockDevice: 'Are you sure to Unblock ?',
  invalidStartDate: 'Invalid Start Date',
  selectStartDate: 'Select Start Date',
  invalidEndDate: 'Invalid End Date',
  selectEndDate: 'Select End Date',
  invalidControllersList: 'Invalid Controllers List',
  downloadingInfo: 'Please wait report is getting ready for Download',
  aggreeWarn: 'Do you agree?',
  downloadsSuccess: 'All the files downloaded Successfully',
  noFiles: 'No files found',
  downloadsCancelled: 'You have cancelled the Downloads',
  downloadError: 'Error downloading driver file',

  deleteGroupSuccess: 'Group deleted successfully',
  deleteGroupFailure: 'Failed to delete group',
  createGroupSuccess: 'Group created successfully',
  editGroupSuccess: 'Group details updated successfully',
  createEditGroupFailure: 'Failed to create/edit group',
  createEditBroadcastMessageFailure: 'Failed to create/edit broadcast Message',
  groupExists: 'Group Name already exist',
  groupExistEdit: 'Group Name already exist/duplicate Group Name',
  groupModelNotValid: 'Model is not valid',
  groupNameDescNotValid: 'Name/Desc is not valid',
  groupDeviceNotValid: 'One/More selcted device is invalid or the user doesn\'t have accescs',
  groupEditNoAccess: 'User doesn\'t have access to the group',
  groupFetchInfoError: 'Failed to fetch data',


  infoMessage: 'Are you sure to Delete Driver?',
  uploadvalidFile: 'Please upload a valid file',
  fileExist: 'Driver file already exists',
  overWriteMsg: 'Are you sure you want to Overwrite!',
  downloadsuccess: 'Download Success!',
  deleteSuccess: 'File Deleted Successfully',
  deleteError: 'Error deleting file ',
  filenotVerified: 'Trying to upload a non verified driver',
  fileuploaded: 'Driver File Uploaded',
  filenamelengtherr: 'File name should not be more than 50 characters',
  badRequest: 'Bad Request',
  invalidInput: 'Invalid input fields',
  invalidTag: 'Invalid Tag Name',
  selectedResourceData: 'Selected Resources Data',
  tagUpdate: 'Tag Updated Successfully',
  validFileError: 'Invalid file type. Please upload valid xml driver file.',
  maxFileSizeErr: 'File size exceeded, maximum permitted size is 5 MB.',
  invalidReportFormat: 'Invalid report format',
  invalidHaccpReport: 'Invalid report name',
  invalidReportDetail: 'Enter valid report name',
  invalidReportFreq: 'Invalid report frequency',
  selectReportFreq: 'Select report frequency',
  invalidDataFreq: 'Invalid data frequency',
  selectDataFreq: 'Select data frequency',
  selectReportFormat: 'Select report format',
  reportAdd: 'added successfully',
  reportUpdated: 'updated successfully',
  reporterrorAdd: 'Error occurred while adding/updating Report, please try again.',
  activeReport: 'Activated successfully',
  deactiveReport: 'Deactivated successfully',
  deleteReport: 'Deleted successfully.',
  confirmDeleteReport: 'Are you sure to Delete Report?',
  errorDeleteReport: 'Error Deleting Report',
  reportModelNotValid: 'Model is not valid',
  noUserAccessToReport: 'User Doesn\'t have access to the Haccp Report',
  reportNameNotValid: 'Report name is not valid',
  invalidReportControllerType: 'Invalid Controller type',
  duplicateReportName: 'Duplicate report name',
  MaxResourceSelected: 'Maximum 8 resources can be selected',
  invalidOId: 'Invalid OID',
  invalidOemName: 'Invalid OEM Name',
  invalidOemDesc: 'Invalid OEM Description',
  oemExists: 'OEM Already exist',
  oemValuesNotValid: 'OID or OEM Name or OEM Desc is not valid',
  favouriteAddedSuccessfuly: ' added to favourite.',
  favouriteNotAddedSuccessfuly: ' failed to add to favourite',
  favouriteRemovedSuccessfuly: ' removed from favourite',
  favouriteNotRemovedSuccessfuly: ' failed to remove from favourite',
  invalidDelay: 'Delay value can\'t be negative',
  invalidCooler: 'Invalid cooler/device',
  isMandatory: ' is Mandatory',
  shouldBePostiveNumber: ' should be postive number',
  fieldCompriseMin: ' field must be comprised of a minimum of ',
  maxOf: ' and a maximum of ',
  isInvalidCharIncludesSpChar: ' is invalid (includes special characters: ',
  characters: ' characters.',
  isInValid: ' is Invalid ',
  atmost: ' should be atmost ',
  chosseAtleastOne: 'Choose atleast one ',
  telemetryDataFetchError: 'Error occurred while getting telemetry data, please try again.',
  readValueFirst: 'Please read values first.',
  currentValInvalid: 'Current feild is Invalid',
  currentValInvalidBool: 'Current feild is Invalid.It can have only True (or 1)/False (or 0) value.',
  currentValInvalidMinMax: 'Current feild is Invalid.Value must be between {min} and {max}',
  currentValInvalidMax: 'Current feild is Invalid.Value can be maximum upto {max}',
  currentValInvalidMin: 'Current feild is Invalid.Value can be minnimum upto {min}',
  roleMandatory: 'Role is Mandatory',
  noResponseFromDevice: 'No response received from device.',
  valueRequired: 'Current value is required.',
  DateOverlapMessage:'Overlap of Message',
  dateoverlapuserMessage: 'Broadcast Message Saved.The date range you\'ve selected for message overlaps with an existing schedule.',
  existingBroadcastMessage: 'Existing Broadcast Message Active',

  broadcastMessageActive: 'Broadcast Message Saved.There\'s already an active broadcast message.',
  broadcastMessage: 'Broadcast Message',
  deleteBroadcastMessageFailure: 'Failed to delete broadcast Message',
  activeMessageWarning: 'Activated successfully.There\'s already an active broadcast message.',
  

}
